
export const BASE_URL = "https://goldwise-dev.com";

export const EMAIL_VERIFICATION_ENDPOINT = "customer/account/verify-email/";
export const EMAIL_SEND_ENDPOINT = "customer/account/email-verification/send/";

// Environment-specific deeplink scheme
const getDeeplinkScheme = () => {
    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
    return (env === 'prod') ? 'goldwise://' : 'goldwise-dev://';
};

const DEEPLINK_SCHEME = getDeeplinkScheme();

export const APP_LINK_REQUEST_VERIFICATION_EMAIL = `${DEEPLINK_SCHEME}app/email/verification-request?token=`;
export const APP_LINK_REQUEST_RESET_PASSWORD = `${DEEPLINK_SCHEME}app/reset-password-request?token=`;
export const APP_LINK_REQUEST_SUCCESS_EMAIL = `${DEEPLINK_SCHEME}app/email/change-request/success?emailChangeValidationToken=`;
export const APP_LINK_REQUEST_SUCCESS_PHONE = `${DEEPLINK_SCHEME}app/number/change-request/success?numberChangeValidationToken=`;
export const APP_LINK_login = `${DEEPLINK_SCHEME}app/login`;

export const ANDROID_APP_LINK = "";
export const IOS_APP_LINK = "";

